import { call, put, select, take } from 'redux-saga/effects';

import { selectDependentFormAssigmentId } from '../selectors';
import { dependentFormActions } from '../progress.actions';
import * as docCompletion from '../documents-completion-req';
import { redirectToRelation } from './redirect-saga';

export function* sendDocuments() {
  const id = yield select(selectDependentFormAssigmentId);

  yield put(docCompletion.actions.send({ id }));
  /** Wait until success response */
  const { payload: assignment } = yield take(docCompletion.consts.SUCCEED);
  yield put(dependentFormActions.updateDependent(assignment));
  yield call(redirectToRelation, id);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/send-documents-saga.js